import { useState, useEffect } from 'react'
import { orgLevelIdAPI } from '../services/organization'

function UseOrgLevelId() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await orgLevelIdAPI()
      if (!result) return

      const newData = result.result.map((d) => {
        return {
          value: d.orgLevelId,
          label: `${d.orgLevelCode} - ${d.orgLevelEn}`
        }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}
export default UseOrgLevelId
